import { HttpClient } from '@angular/common/http';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UserSpaceLimitWarningMessage } from 'src/app/models/error';
import { SAAMAirSpace } from 'src/app/models/saamAirSpace';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { PointsService } from 'src/app/services/points.service';
import { SaamTrafficService } from 'src/app/services/saamtrafficservice';
import { UiBlockService } from 'src/app/services/ui-block.service';

@Component({
  selector: 'app-saamtrafic-import',
  templateUrl: './saamtrafic-import.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class SAAMtraficImportComponent implements OnInit {
  @Input()
  file: File;

  layerName: string;
  constructor(public bsModalRef : BsModalRef,
    private http : HttpClient,
    private endpointService : EndpointsService,
    private pointsService: PointsService,
    private saamService: SaamTrafficService,
    private uiBlock : UiBlockService,
    private modalService : ModalControlService,
    ) { }

  ngOnInit(): void {
  }
  changeLayerName(name: string){
    this.layerName = name;
  }

  @HostListener('document:keydown.escape', ['$event']) 
  onEscape(event: KeyboardEvent) {
    this.close(false); // escape key already hides the modal
  }

  close(hideModal: boolean = true){
    this.file = null;
    this.layerName = null;
    hideModal? this.bsModalRef.hide(): false;
  }
  submit(){
    this.uiBlock.startBlock("Importing SAAM layer...");
    const formData: FormData = new FormData();
    formData.append('file', this.file, this.layerName);
    this.http.post(this.endpointService.endpointParseSAAMTrafficFile,
      formData,
      this.endpointService.httpOptions
      ).
      subscribe((data:SaamFromDatabase)=>
        {
         // localStorage.setItem("SaamTrafficLayer",JSON.stringify(data))
          this.saamService.addSAAMAirSpaceToMap(data);
          this.bsModalRef.hide();
          this.uiBlock.stopBlock();
          this.modalService.showMesssageModal('Import SAAM','Import SAAM was successful')

        },
        (error)=>{
          if(error && error.status == 507){
            this.bsModalRef.hide();
            this.uiBlock.stopBlock();
            this.modalService.showMesssageModal("Warning",UserSpaceLimitWarningMessage);
            this.pointsService.deleteSAAMLayersFromMap();
            this.uiBlock.startBlock("Loading SAAM Layers");
            this.http.get(
              this.endpointService.endpointGetAllSAAMTraffic,
            this.endpointService.httpOptions
          ).subscribe((data:SaamFromDatabase[]) =>{
            data.forEach((saamFromDataBase:SaamFromDatabase )=>{
              this.saamService.addSAAMAirSpaceToMap(saamFromDataBase)
            })
            this.uiBlock.stopBlock();
          })
        }
        }
      )
  }
}
export class SaamFromDatabase{
  id: number;
  saamairspacestring: string;
}
